<div class="p-4">
  <!-- Trust and safety section -->
  <div class="px-3 pt-3 pb-4 bg-bush-green-10 rounded">
    <div class="flex items-center subtitle-1">
      <span>{{ 'aiHub.data.trustAndSafety' | translate }}</span>
      <button
        type="button"
        class="ml-auto p-0 border-0 bg-transparent cursor-pointer"
        [attr.aria-expanded]="noteDataIsSecureExpanded()"
        [attr.aria-label]="
          (noteDataIsSecureExpanded()
            ? 'aiHub.trustAndSafety.showLess'
            : 'aiHub.trustAndSafety.learnMore'
          ) | translate
        "
        (click)="toggleTrustAndSafety()"
      >
        <span
          class="fa-icons icon-16 text-finserv-100"
          [class.icon-chevron-up]="noteDataIsSecureExpanded()"
          [class.icon-chevron-down]="!noteDataIsSecureExpanded()"
        ></span>
      </button>
    </div>

    @if (noteDataIsSecureExpanded()) {
      <div class="flex gap-2 mt-3">
        <span
          class="fa-icons icon-solid icon-16 icon-shield-check text-finserv-100 shrink-0 mt-0.5"
        ></span>
        <p
          class="text-body-2 m-0 whitespace-pre-wrap"
          [innerHTML]="
            ('aiHub.dataIsSecure' | translate)
              | regexReplace: '\\\\r\\\\n' : '\r\n'
              | regexReplace: '\\\\' : ''
          "
        ></p>
      </div>

      <div class="flex gap-2 mt-3">
        <span
          class="fa-icons icon-solid icon-16 icon-scale-balanced shrink-0 mt-0.5"
        ></span>
        <p
          class="text-body-2 m-0 whitespace-pre-wrap"
          [innerHTML]="
            ('aiHub.noticeForUsage' | translate)
              | regexReplace: '\\\\r\\\\n' : '\r\n'
              | regexReplace: '\\\\' : ''
          "
        ></p>
      </div>

      <button
        type="button"
        class="flex items-center gap-1 mt-3 ml-6 p-0 border-0 bg-transparent text-body-2 cursor-pointer text-info"
        (click)="toggleTrustAndSafety()"
      >
        <span
          class="fa-icons icon-16 icon-chevron-up text-info"
        ></span>
        <span class="pl-2 pt-1 font-semibold">{{ 'aiHub.trustAndSafety.showLess' | translate }}</span>
      </button>
    } @else {
      <div class="flex gap-2 mt-3">
        <span
          class="fa-icons icon-solid icon-16 icon-shield-check text-finserv-100 shrink-0 mt-0.5"
        ></span>
        <p class="text-body-2 m-0">
          {{ 'aiHub.trustAndSafety.summary1' | translate }}
        </p>
      </div>

      <div class="flex gap-2 mt-3">
        <span
          class="fa-icons icon-solid icon-16 icon-scale-balanced shrink-0 mt-0.5"
        ></span>
        <p class="text-body-2 m-0">
          {{ 'aiHub.trustAndSafety.summary2' | translate }}
        </p>
      </div>

      <div class="flex gap-2 mt-3">
        <span
          class="fa-icons icon-solid icon-16 icon-circle-info shrink-0 mt-0.5"
        ></span>
        <p class="text-body-2 m-0">
          {{ 'aiHub.trustAndSafety.summary3' | translate }}
        </p>
      </div>

      <button
        type="button"
        class="flex items-center gap-1 mt-3 ml-6 p-0 border-0 bg-transparent text-body-2 cursor-pointer text-info"
        (click)="toggleTrustAndSafety()"
      >
        <span
          class="fa-icons icon-16 icon-chevron-down"
        ></span>
        <span class="pl-2 pt-1 font-semibold">{{ 'aiHub.trustAndSafety.learnMore' | translate }}</span>
      </button>
    }
  </div>

  <!-- AI Enable/Disable section -->
  <div class="my-6">
    <h6 class="mb-1">
      {{ 'aiHub.enableSettings.title' | translate }}
    </h6>
    <p class="text-body-2 mb-6">
      {{ 'aiHub.enableSettings.description' | translate }}
    </p>

    <p class="subtitle-2 mb-3">
      {{ 'aiHub.enableSettings.organizationWideTitle' | translate }}
    </p>

    <div class="flex items-start gap-2">
      <kendo-switch
        size="large"
        [ngModel]="isAiEnabled()"
        [disabled]="!isAdmin()"
        (valueChange)="setAiEnabled($event)"
      ></kendo-switch>
      <div class="flex flex-col pt-0.5 -mt-1">
        <span class="subtitle-2 text-neutral-90">
          {{ 'aiHub.enableSettings.iqBoost.title' | translate }}
        </span>
        <span class="text-caption text-neutral-70">
          {{ 'aiHub.enableSettings.iqBoost.description' | translate }}
        </span>
      </div>
    </div>

    <div class="flex items-start">
      <div class="anonymizer-connector shrink-0"></div>
      <div class="flex items-start gap-2 flex-1 min-w-0 mt-2">
        <kendo-switch
          size="medium"
          class="mt-5"
          [ngModel]="isAnonymizerEnabled()"
          [disabled]="isAnonymizerToggleDisabled()"
          (valueChange)="setAnonymizerEnabled($event)"
        ></kendo-switch>
        <div class="flex flex-col mt-2 min-w-0">
          <div class="flex items-center flex-wrap gap-2">
            <span
              class="maximizer-icons icon-anonymizer icon-16 shrink-0 text-black pt-0.5"
            ></span>
            <span class="subtitle-2 text-neutral-90 pt-1">
              {{ 'aiHub.enableSettings.anonymizer.title' | translate }}
            </span>
            @if (!isFFAnonymizerEnabled()) {
              <span
                class="text-caption inline-flex items-center gap-1 p-2 bg-neutral-5 rounded-sm h-6 leading-3"
              >
                <span
                  class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
                ></span>
                <span
                  [innerHTML]="'permissions.organizationPermissionMessage' | translate"
                ></span>
              </span>
            } @else if (!isAdmin() && isAnonymizerEnabledByAdmin()) {
              <span
                class="text-caption inline-flex items-center gap-1 p-2 bg-bush-green-5 rounded-sm h-6 leading-3"
              >
                <span
                  class="fa-icons icon-toggle-on icon-solid icon-16 text-black shrink-0 pr-1"
                ></span>
                <span
                  [innerHTML]="'permissions.adminPermissionEnabledMessage' | translate"
                ></span>
              </span>
            }
          </div>
          <span class="text-caption text-neutral-70 pt-0.5">
            {{ 'aiHub.enableSettings.anonymizer.description' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Progress bar section -->
  @if (aiStore.isCreditSystemEnabled()) {
    <div class="my-2 p-4 bg-white rounded-sm border border-neutral-25">
      <div class="flex justify-between items-center mb-2">
        <h3 class="subtitle-1 font-medium text-neutral-90">
          {{ 'aiHub.premiumFeatures.title' | translate }}
        </h3>
      </div>

      <div class="w-full bg-neutral-20 rounded-full h-2 mb-1 overflow-hidden">
        @if (!aiStore.isEarlyAccess()) {
          <div
            class="bg-primary-100 h-2 rounded-full transition-all duration-300 ease-in-out"
            [style.width.%]="creditsProgressPercentage()"
            [title]="'Progress: ' + creditsProgressPercentage() + '%'"
            [style.min-width.px]="creditsProgressPercentage() > 0 ? 4 : 0"
          ></div>
        } @else {
          <div
            class="w-full bg-bush-green-100 h-2 rounded-full transition-all duration-300 ease-in-out"
          ></div>
        }
      </div>

      <p
        [ngClass]="{
          'bg-bush-green-10 p-1 px-2 rounded-sm inline-block':
            aiStore.isEarlyAccess(),
          'mb-2': !aiStore.isEarlyAccess(),
        }"
        class="text-xs text-black"
      >
        @if (aiStore.isEarlyAccess()) {
          {{ 'ai.earlyAccess' | translate }}
        } @else {
          {{ creditsUsed() | number: '1.0-0' }}/{{
            creditsTotal() | number: '1.0-0'
          }}
          {{ 'aiHub.premiumFeatures.creditsLeft' | translate }}
        }
      </p>
    </div>
  }

  <!-- Features section -->
  <div class="block w-full">
    <div class="mb-2">
      <span class="subtitle-2 text-black">{{ 'aiHub.features.title' | translate }}</span>
    </div>

    @for (group of aiFeaturesGroup(); track group.category) {
      @if (group.category) {
        <div class="my-5">
          <span class="subtitle-1 text-neutral-90">{{ group.category }}</span>
        </div>
      }

      <div class="flex w-full">
        <div class="flex flex-wrap gap-4 w-full">
          @for (feature of group.items; track feature.title) {
            <div
              class="flex flex-col justify-between border rounded-sm border-neutral-25 p-4 w-[calc(50%-0.5rem)]"
            >
              <div class="flex items-center mb-[1.125rem]">
                <kendo-switch
                  size="medium"
                  [(ngModel)]="feature.enabled"
                  [disabled]="
                    !isFeatureEnabled(feature) ||
                    !isFeatureEnabledByOrganization(feature) ||
                    !isAiEnabled()
                  "
                  [checked]="true"
                  (valueChange)="onFeatureToggle(feature)"
                ></kendo-switch>
                <span [ngClass]="feature.iconClass"></span>
                <span class="menu-1 text-neutral-90 ml-2">{{
                  feature.title
                }}</span>

                <div class="ml-auto">
                  @if (!isFeatureEnabledByOrganization(feature)) {
                    <div
                      class="h-min-7 text-body-2 bg-neutral-5 rounded-sm py-1 px-3 inline-flex items-center gap-1"
                    >
                      <span
                        class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
                      ></span>
                      <span
                        [innerHTML]="
                          'permissions.organizationPermissionMessage' | translate
                        "
                      ></span>
                    </div>
                  } @else if (!isFeatureEnabled(feature)) {
                    <div
                      class="h-min-7 text-body-2 bg-neutral-5 rounded-sm py-1 px-3 inline-flex items-center gap-1"
                    >
                      <span
                        class="fa-icons icon-toggle-off icon-solid icon-16 text-black shrink-0 pr-1"
                      ></span>
                      <span
                        [innerHTML]="
                          'permissions.adminPermissionMessage' | translate
                        "
                      ></span>
                    </div>
                  }
                </div>
              </div>

              <div class="my-1 mb-[1.125rem]">
                <span class="block text-body-2 text-black mb-4">
                  {{ feature.description }}
                </span>

                @if (feature.imgSrc) {
                  <div class="flex gap-4">
                    <div class="flex-1 flex flex-col">
                      <span
                        class="block text-body-2 text-black"
                        [innerHTML]="feature.location"
                      ></span>

                      @if (feature.app) {
                        <button
                          kendoButton
                          themeColor="tertiary"
                          [disabled]="!feature.enabled || !isAiEnabled()"
                          (click)="openFeature(feature.app)"
                          class="mt-auto ml-auto"
                        >
                          {{ 'aiHub.data.launch' | translate }}
                          {{ feature.app.title }}
                        </button>
                      }
                    </div>

                    <div
                      class="flex-shrink-0 flex flex-col items-end justify-end"
                    >
                      <img
                        [src]="feature.imgSrc"
                        [alt]="feature.title + ' preview'"
                        class="rounded-sm max-w-64"
                        loading="lazy"
                      />
                    </div>
                  </div>
                } @else {
                  <span
                    class="block text-body-2 text-black"
                    [innerHTML]="feature.location"
                  ></span>
                }
              </div>

              <div class="flex justify-between items-end mt-auto">
                <div class="block">
                  @if (feature.limitation) {
                    <span class="block text-body-2 text-neutral-70 mb-2">
                      {{ feature.limitation }}
                    </span>
                  }

                  <span class="block text-body-2 text-neutral-90">
                    {{ 'aiHub.data.label' | translate }}
                  </span>
                  <span class="block text-caption text-neutral-70">
                    {{ feature.data }}
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

@if (loading()) {
  <div
    class="absolute flex items-center justify-center w-full h-full top-0 left-0 z-50"
  >
    <img [src]="loadingGifUrl()" alt="Loading…" loading="lazy" />
    <div
      class="z-10 absolute w-full h-full top-0 left-0 bg-white opacity-30"
    ></div>
  </div>
}
